import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Vuetify from 'vuetify'
// import lt from './locales/lt.json'
// import en from './locales/en.json'

Vue.use(VueI18n)

// const messages = {
//   lt,
//   en,
// }

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE,
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'lt',
//   messages: messages,
// })

// Vue.use(Vuetify, {
//   lang: {
//     locales: { lt, en },
//     current: process.env.VUE_APP_I18N_LOCALE,
//   },
// })

// Vue.use(Vuetify, {
//   lang: {
//     t: (key, ...params) => this.$i18n.t(key, params),
//   },
// })

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  lt: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
  },
}

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  lt: {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
  },
}

export default new VueI18n({
  locale:
    window.localStorage.getItem('language') ||
    process.env.VUE_APP_I18N_LOCALE ||
    'lt',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'lt',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  formatFallbackMessages: true,
  dateTimeFormats,
  numberFormats,
  messages: loadLocaleMessages(),
})
